import { pagedListWrapper } from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { Rank } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const ranks = pagedListWrapper<'position', Rank>()(apiClient, {
      path: `/api/v${version}/ranks`,
      idKey: 'position'
    })

    return { ranks }
  }
} satisfies Starter
